export default __webpack_public_path__ + "gray_matter/reference-f7eac2135e08588ab041372d2c8e3b30.svg";